type PaginationProps = {
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void;
};

export default function Pagination({ currentPage, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <nav className="mt-8 flex items-center justify-center gap-2" aria-label="分页">
      <button
        type="button"
        onClick={() => onChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="flex h-9 items-center gap-1 rounded-md border border-background-200 px-3 text-sm text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-200 disabled:hover:text-foreground-700"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`flex h-9 w-9 items-center justify-center rounded-md text-sm transition-colors ${
            page === currentPage
              ? "bg-primary-500 font-semibold text-background-50"
              : "border border-background-200 text-foreground-700 hover:border-accent-400 hover:text-accent-600"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="flex h-9 items-center gap-1 rounded-md border border-background-200 px-3 text-sm text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-200 disabled:hover:text-foreground-700"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}